<template>
  <div class="map">
    <!-- Same markup as Map.cshtml -->
    <div class="o-map">
      <div id="map-entrepreneurs" class="entreprises-map"></div>
    </div>
    <!-- Error popup -->
    <generic-popup v-model="showErrorPopup" :title="$t('map-find-by-location-browser-error-title')" :text="$t('map-find-by-location-browser-error-text')" />
    <!-- Controls overlay the map -->
    <div class="map__control">
      <div class="map__address">
        <googlemap-autocomplete v-model="mapSearch" class="map__address-field" @place="setPlace" :placeholder="$t('map-find-by-text-location-placeholder')" :hideLabel="true" :mapStyle="true" />
      </div>
      <button @click="searchNearMe" type="button" class="map__geoloc a-btn-primary-outline o-filters__btn">
        <span class="map__geoloc-icon"></span>
        <span class="map__geoloc-label">
          {{ $t('map-find-by-location-btn') }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import GooglemapAutocomplete from '@/components/form/googlemap-autocomplete'
import GenericPopup from '@/components/popup/generic-popup'

export default {
  components: {
    GooglemapAutocomplete,
    GenericPopup
  },
  data: function () {
    return {
      map: null,
      debounceTimeout: null,
      debounceDelay: 200,
      showErrorPopup: false,
      mapSearch: ''
    }
  },
  props: {
    gatherings: {
      type: Array,
      required: true
    },
    businesses: {
      type: Array,
      required: true
    }
  },
  watch: {
    gatherings: function () {
      this.update()
    },
    businesses: function () {
      this.update()
    }
  },
  methods: {
    update() {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout)
      }

      if (!this.map || !this.map.updateMarkers) {
        return
      }

      this.debounceTimeout = setTimeout(() => {
        this.map.updateMarkers({
          organizations: this.gatherings,
          companies: this.businesses
        })
      }, this.debounceDelay)
    },
    setPlace: function (place) {
      this.updateMapLocation(place.geometry.location.lng(), place.geometry.location.lat())
    },
    searchNearMe: function () {
      this.mapSearch = ''
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.searchNearMeSuccess)
      } else {
        this.showErrorPopup = true
      }
    },
    searchNearMeSuccess: function (position) {
      this.updateMapLocation(position.coords.longitude, position.coords.latitude)
    },
    updateMapLocation: function (longitude, latitude) {
      if (!this.map || !this.map.panToLatLng) {
        return
      }
      this.map.setView(latitude, longitude, 15)
    }
  },
  async mounted() {
    if (!window.MapFactory) return
    this.map = await window.MapFactory('map-entrepreneurs')
    this.update()
  }
}
</script>

<style lang="scss" scoped>
.map {
  height: 100%;
  width: 100%;
  position: relative;

  &__control {
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
    padding: 8px 4px 0;
    display: flex;
    max-width: 100%;
  }

  &__address {
    display: block;
    flex: 0 1 auto;
    margin: 0 4px;
    width: 450px;

    &-field {
      margin: 0;
    }
  }

  &__geoloc {
    background-color: #fff;
    color: #000;
    border: 0;
    padding: 8px 17px;
    display: block;
    flex: 0 0 auto;
    margin: 0 4px;

    &-icon {
      background: url(~@/assets/geolocation.svg);
      width: 20px;
      height: 20px;
      background-size: 20px;
      display: inline-block;
      vertical-align: text-top;
    }

    &-label {
      display: none;
    }
  }
}

@media (min-width: 768px) {
  .map {
    &__control {
      padding: 20px 10px 0;
    }

    &__address {
      margin: 0 10px;
    }

    &__geoloc {
      padding: 8px 10px;
      margin: 0 10px;

      &-label {
        display: inline;
      }
    }
  }
}
</style>